import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import moment from 'moment';
import { Button } from 'reactstrap';
import { Paper } from '@mui/material';

const defaultColDef = {
  resizable: false,
  sortable: false,
  filter: false,
  suppressMovable: true,
  cellStyle: { padding: 0 },
};

const columnDefs = [
  {
    headerName: '',
    field: 'details',
    cellRenderer: 'detailCellRenderer',
    autoHeight: true,
    suppressSizeToFit: false,
  },
];

export class WorkOrderIntTableHistorySmall extends Component {
  static displayName = WorkOrderIntTableHistorySmall.name;

  constructor(props) {
    super(props);
    this.state = {
      gridApi: null,
      gridColumnApi: null,
    };
  }

  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    });
    params.api.sizeColumnsToFit();
  };

  detailCellRenderer = (params) => {
    const workorder = params.data;
    const rowIndex = params.rowIndex;

    const showFinalConf =
      workorder.intConfFlg !== true &&
      moment(workorder.jobDateTime).format('YYYY-MM-DD') ===
        moment().add(1, 'days').format('YYYY-MM-DD');

    const showEndTime =
      workorder.finishTime === null && workorder.intConfFlg === true;

    return (
      <div className="p-2">
        {/* Header Row */}
        <div
          className="d-flex justify-content-between align-items-center mb-2 p-2"
          style={{ backgroundColor: '#f7ac81' }}
        >
          <div>ID: {workorder.jobNum}</div>
        </div>

        {/* Details */}
        <div className="small-grid-details">
          <div className="d-flex justify-content-between">
            <div>
              <strong>Date:</strong>{' '}
              {moment(workorder.jobDateTime).format('MM/DD/YYYY hh:mm A')}
            </div>
          </div>

          <div className="my-1">
            <strong>Claimant:</strong>{' '}
            {workorder.hasClaimantDupWO ? (
              <span style={{ color: 'red' }}>
                {workorder.clmFirstName} {workorder.clmLastName}
              </span>
            ) : (
              `${workorder.clmFirstName} ${workorder.clmLastName}`
            )}
          </div>

          {workorder.providerName && (
            <div className="my-1">
              <strong>Provider:</strong> {workorder.providerName}
            </div>
          )}

          <div className="d-flex justify-content-between">
            <div>
              <strong>Chk#:</strong> {workorder.intCheckNum}
            </div>
            <div>
              <strong>Chk Date:</strong>{' '}
              {workorder.intCheckDate &&
                moment(workorder.intCheckDate).format('MM/DD/YYYY')}
            </div>
          </div>

          <div className="d-flex justify-content-between">
            <div>
              <strong>Fee:</strong>{' '}
              {workorder.intFee !== null && `$${workorder.intFee}`}
            </div>
            <div>
              <strong>OT:</strong>{' '}
              {workorder.intOTFee !== null && `$${workorder.intOTFee}`}
            </div>
          </div>

          <div className="d-flex justify-content-between">
            <div>
              <strong>OTH:</strong>{' '}
              {workorder.intFeeOther !== null && `$${workorder.intFeeOther}`}
            </div>
            <div>
              <strong>Total:</strong>{' '}
              {(() => {
                const fee = workorder.intFee || 0;
                const otFee = workorder.intOTFee || 0;
                const otherFee = workorder.intFeeOther || 0;
                const total = fee + otFee + otherFee;
                return total > 0 ? `$${total}` : '';
              })()}
            </div>{' '}
          </div>

          <div className="mt-1">
            <strong>Address:</strong>{' '}
            {`${workorder.aptStreet} ${workorder.aptCity} ${workorder.aptState} ${workorder.aptZip}`}
          </div>


          {workorder.attachmentFileLocationS3 && (
            <div className="mt-2">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.context.componentParent.props.onDownloadAttachment(
                    workorder.attachmentJobHistoryId,
                    workorder.attachmentFileName
                  );
                }}
              >
                Download Attachment
              </a>
            </div>
          )}
        </div>
      </div>
    );
  };

  render() {
    const gridOptions = {
      columnDefs: columnDefs,
      rowData: this.props.workOrders,
      defaultColDef: defaultColDef,
      components: {
        detailCellRenderer: this.detailCellRenderer,
      },
      getRowHeight: () => 260,
      context: {
        componentParent: this,
      },
      domLayout: 'autoHeight',
      suppressHorizontalScroll: true,
    };

    return (
      <div style={{ height: 'calc(100dvh - 120px)', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
        <Paper className="ag-theme-balham" style={{ width: '100%' }}>
          <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
        </Paper>
      </div>
    );
  }
}
